<button [attr.aria-label]="ariaLabel"
        [disabled]="disabled"
        [attr.form]="form"
        [autofocus]="autofocus"
        matRipple
        [tabindex]="tabindex"
        [type]="actionType"
        class="composable-element"
> <!-- Leave ripple because there is no user feedback at this moment -->
  <span class="start-icon">
    <ng-content select="[slot='start']"></ng-content>
  </span>
  <span class="text">
    <ng-content></ng-content>
  </span>
  <span class="end-icon">
    <ng-content select="[slot='end']"></ng-content>
  </span>

  <span #onlyIcon class="only-icon">
    <ng-content select="[slot='only-icon']"></ng-content>
  </span>
</button>
